module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_7_1.d4230680.jpeg";